<template>
  <div class="hidden-schemes-page">
    <div class="text-h4 q-mb-md text-left tab-heading-color">
      Verborgen regelingen
    </div>
    <q-card>
      <div id="q-app" style="min-height: 100vh;">
        <div class="q-pa-md">
          <q-table
            :rows="hiddenSchemesItems"
            :columns="hiddenSchemesColumns"
            row-key="id"
            :filter="filterSchemes"
            :filter-method="schemesFilter"
            :rows-per-page-label="'Resultaten per pagina'"
          >
            <template v-slot:top>
              <q-input
                borderless
                dense
                debounce="300"
                color="primary"
                placeholder="Zoek"
                v-model="filterSchemes"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
              <q-space />
              <q-btn class="save-btn outline flat" @click="unhideSchemes()">
                Allen herstellen
              </q-btn>
            </template>

            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="name" :props="props">{{ props.row.name }}</q-td>
                <q-td key="status" :props="props">{{ props.row.status }}</q-td>
                <q-td key="actions" :props="props" class="q-gutter-xs">
                  <q-btn
                    color="light-blue-1"
                    @click="unhideScheme(props.row.id)"
                    size="sm"
                    no-caps
                  >
                    <i class="las la-2x la-history" style="color: #0a108f"></i>

                    <q-tooltip>
                      Terugzetten
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import store from '../../store/index.js';
import GrantsService from '../../services/grants.service';

export default {
  name: 'HiddenSchemes',
  setup() {
    const hiddenSchemesColumns = [
      {
        name: 'name',
        align: 'left',
        label: 'Naam',
        field: 'name',
        sortable: true,
      },
      {
        name: 'status',
        align: 'left',
        label: 'Status',
        field: 'status',
        sortable: true,
      },
      { name: 'actions', align: 'center' },
    ];

    const filterSchemes = ref('');
    const loading = ref(false);

    const hiddenSchemesItems = computed({
      get: () => store.state.user.hiddenSchemesList,
    });

    const unhideScheme = (schemeId) => {
      GrantsService.unhideScheme(schemeId);
    };

    const unhideSchemes = () => {
      var list = [];
      for (let i = 0; i < hiddenSchemesItems.value.length; i++) {
        list.push(hiddenSchemesItems.value[i].id);
      }
      GrantsService.unhideSchemes(list);
    };

    return {
      unhideSchemes,
      hiddenSchemesColumns,
      hiddenSchemesItems,
      filterSchemes,
      loading,
      unhideScheme,
      schemesFilter(rows, terms) {
        // rows contain the entire data
        // terms contains whatever you have as filter
        const lowerFilter = terms ? terms.toLowerCase() : '';
        if (lowerFilter != '') {
          return rows.filter(
            (row) => row.name.toLowerCase().indexOf(lowerFilter) > -1
          );
        } else {
          return rows;
        }
      },
    };
  },
};
</script>
